import { BoxProps, Stack, Text, useTheme } from '@chakra-ui/react';

import { Loader } from 'ui';

interface ContentLoaderProps extends BoxProps {
  label: string;
  isLoading: boolean;
  minHeight?: string | { [key: string]: string };
  isRedVariant?: boolean;
}

const ContentLoader = ({
  isLoading,
  label,
  minHeight = '150px',
  isRedVariant = false,
  ...rest
}: ContentLoaderProps) => {
  const {
    colors: {
      palette: {
        components: { contentLoader }
      }
    }
  } = useTheme();

  return (
    <Stack
      alignItems='center'
      justifyContent='center'
      width='100%'
      position='relative'
      minHeight={minHeight}
      {...rest}
    >
      {isLoading ? (
        <Loader fixed bg='blackOpacity.10' />
      ) : (
        <Text
          textAlign='center'
          color={
            isRedVariant
              ? contentLoader.redVariantColor
              : contentLoader.defaultColor
          }
          fontSize='16px'
          textTransform={isRedVariant ? 'capitalize' : 'uppercase'}
        >
          {label}
        </Text>
      )}
    </Stack>
  );
};

export default ContentLoader;
